
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#269C45","stroke-width":"1.6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21.082 26.422L4.035 32.678c-.624.235-1.076-.06-1.076-1.154 0-11.232 11.427-11.356 18.123-9.442m-.009-.823V2.767c-.006-.668.421-.978 1.452-.61 10.685 3.785 7.232 13.596 4.287 19.102m.031.476l17.233 7.938c.604.27.727.794-.048 1.575-6.491 6.558-13.288 1.808-17.216-2.846M46 46H2"}}),_c('path',{attrs:{"d":"M21.073 21.242a2.87 2.87 0 115.74 0v24.751h-5.74V21.242z"}})])])
          )
        }
      }
    